const WHATSAPP_HOSTNAMES = ['wa.me', 'api.whatsapp.com'];

export default function isWhatsappLink(url: string) {
  try {
    const { hostname } = new URL(url);
    return WHATSAPP_HOSTNAMES.includes(hostname);
  } catch {
    return false;
  }
}
